import { signal } from '@preact/signals-react'

export const permissionDefinitionsSignal = signal([])
export const permissionDefinitionsLoadedSignal = signal(false)
export const permissionDefinitionsErrorSignal = signal(null)

export const userPermissionMasksSignal = signal(null)
export const userPermissionMasksLoadedSignal = signal(false)
export const userPermissionMasksErrorSignal = signal(null)

export const userPermissionsSignal = signal([])
export const userPermissionsSummarySignal = signal(null)